import axios from 'axios'

const BASE = import.meta.env.VITE_WP_BASE_URL

export async function loginUser(email, password) {
  const { data } = await axios.post(`${BASE}/wp-json/farafeero/v1/auth/login`, {
    username: email,
    password,
  })
  return data // { token, user_email, user_display_name }
}

export async function registerUser(payload) {
  const { data } = await axios.post(`${BASE}/wp-json/farafeero/v1/auth/register`, payload)
  return data
}

export async function getMe(token) {
  const { data } = await axios.get(`${BASE}/wp-json/farafeero/v1/auth/me`, {
    headers: { Authorization: `Bearer ${token}` },
  })
  return data
}
